import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

export const EmailValidationRules: EntityValidationRules<NotificationPreferences> = {
  emailAddress: {
    isEmail: true,
  },
};

export const EmailConfirmationValidationRules: EntityValidationRules<NotificationPreferences> = {
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export const EmailNotificationValidationRules: EntityValidationRules<NotificationPreferences> = {
  _emailAddressNotification: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
};

export default class NotificationPreferences {
  @observable
  _notificationEnabled = false;

  @observable
  phoneNumber?: string;

  @observable
  smsNotificationEnabled = false;

  @observable
  emailAddress?: string;

  @observable
  emailNotificationEnabled = false;

  @observable
  _emailAddressNotification?: string;

  @observable
  _isNotificationEmailSame = false;

  @observable
  _emailConfirmation?: string;

  @computed
  get rules(): EntityValidationRules<NotificationPreferences> {
    return {
      ...EmailValidationRules,
      ...EmailConfirmationValidationRules,
    };
  }

  @computed
  get editRules(): EntityValidationRules<NotificationPreferences> {
    return {
      ...EmailValidationRules,
      ...EmailConfirmationValidationRules,
      ...(this._isNotificationEmailSame ? EmailNotificationValidationRules : {}),
      ...(this._notificationEnabled ? NotificationValidationRules : {}),
    };
  }
}

export const NotificationValidationRules: EntityValidationRules<NotificationPreferences> = {
  emailAddress: {
    isEmail: true,
  },
  _emailConfirmation: {
    equalWith: { property: "emailAddress" as const },
    isEmail: true,
  },
  _emailAddressNotification: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !entity.phoneNumber && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isEmail: {
      required: false,
    },
  },
  phoneNumber: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !entity._emailAddressNotification && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isPhoneNumber: {
      required: false,
    },
  },
};

export const NotificationSalespointKiosValidationRules: EntityValidationRules<NotificationPreferences> = {
  emailAddress: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !!entity._emailConfirmation,
      customMessage: "requiredContact",
    },
    isEmail: {
      required: false,
    },
  },
  _emailConfirmation: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !!entity.emailAddress,
      customMessage: "requiredContact",
    },
    equalWith: { property: "emailAddress" as const },
    isEmail: {
      required: false,
    },
  },
  phoneNumber: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !entity._emailAddressNotification && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isPhoneNumber: {
      required: false,
    },
  },
  _emailAddressNotification: {
    requiredIf: {
      condition: (entity: NotificationPreferences) => !entity.phoneNumber && entity._notificationEnabled,
      customMessage: "requiredContact",
    },
    isEmail: {
      required: false,
    },
  },
};

export type ContactEditationTriggerer = "licensePlateChange" | "validityChange" | "contactChange" | "receiptChange";
